<template>
  <div v-scroll="onScroll" v-resize="onResize">
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 9" :key="n" cols="12" sm="6" lg="3">
       <v-sheet class="mt-2">
        <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
      </v-sheet>
      </v-col>
    </v-row>
    <form-data :references.sync="formReferences" :model="supplierObj" ref="supplierOrderRef" v-else>
      <template slot="custom_fields">
        <v-layout wrap class="pa-0">
          <v-flex sm12 lg6 xs12>
            <v-layout wrap class="pa-0">
              <v-flex sm6 lg6>
                <v-select dense hide-details outlined v-model="supplierObj.status" :label="$t('message.customer.status')"
                  :disabled="disableStatusChange" :items="statusList" item-text="name" item-value="id"
                  ></v-select>
                <v-select dense hide-details outlined class="mt-3" v-model="supplierObj.responsible" :label="$t('message.deviations.responsible')"
                  :disabled="disableStatusChange" :items="listOfUsers" item-text="fullname" item-value="id"
                 ></v-select>
                  <div class="mt-3">
                     <b
                    >{{ $t("message.common.total") }}:
                    {{ totalPrice | replaceDotWithComma }}&nbsp;{{
                      supplierCurrency
                    }}</b>
                  </div>
              </v-flex>
              <v-flex sm6 lg6>
                <v-file-input v-model="supplierObj.file" dense hide-details outlined
                  :disabled="disableFormFields" multiple
                  accept=".xlsx, .xls, image/*, .doc, .docx, .txt, .pdf" :label="$t('message.settings.standardInvoiceText')"></v-file-input>
                <div v-for="(element, index) in orderAttachment" :key="index">
                  <v-flex lg12 class="pa-1 pr-2">
                    <a @click="downloadAttachment(index)">{{ element.fileoriginalname }}</a> <v-icon :disabled="supplierObj.status === 'received'" @click="deleteAttachment(index)">delete</v-icon>
                  </v-flex>
                </div>
              </v-flex>
            </v-layout>
            <!-- <v-layout wrap class="pa-0">
              <v-flex pt-0 class="mt-0" v-show="lastUpdatedShow">
                <b
                  >{{ $t("message.orders.lastUpdated") }}&nbsp; by
                  {{ lastUpdated }}</b
                >
              </v-flex>
            </v-layout> -->
          </v-flex>
          <v-flex sm12 lg6 xs12>
            <v-layout wrap class="pa-0">
              <v-flex sm12 lg10>
                <v-textarea outlined hide-details dense v-model="supplierObj.comments" @change="autoSave" :label="$t('message.common.comments')"></v-textarea>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-row class="mx-0 mb-1">
            <v-col cols="12" lg="5" class="mt-2">
              <b v-show="lastUpdatedShow">{{ $t("message.orders.lastUpdated") }}&nbsp; by
                {{ lastUpdated }}</b>
            </v-col>
            <v-col cols="12" lg="2" class="py-0 mt-2">
              <v-btn color='primary' v-if="supplierObj.status === 'inprogress'" :loading="receiveAllLoader" @click="receiveAllHandler">
                {{ $t("message.whOrder.receiveAll") }}
              </v-btn>
            </v-col>
            <v-col cols="12" lg="5" v-if="supplierObj.id" class="py-0">
              <v-layout wrap class="px-3">
                <v-spacer></v-spacer>
                <v-btn color='info' class="mt-6" @click="attachmentsDialog = true">
                  <v-icon color="white" class="mdi-rotate-315">mdi-attachment</v-icon> {{ $t('message.product.attachments') }}
                  <span v-if="attachmentsCountLoading">&nbsp;(<span>
                    <v-progress-circular
                      indeterminate
                      color="white"
                      x-small
                      :size="12"
                      :width="2"
                    ></v-progress-circular>
                  </span>)</span>
                  <span v-else>&nbsp;({{attachmentsCount}})</span>
                </v-btn>
              </v-layout>
            </v-col>
          </v-row>
        </v-layout>
      </template>
      <template slot="extraDetails" class="mb-3">
        <v-form ref="orderItems">
          <v-row class="mt-2">
            <v-col cols="11">
              <v-row class="ml-2">
                <v-col cols="3" sm="2" md="1" lg="1" class="pa-0" v-if="supplierObj.supplierid && isItemsSelectedForDelete">
                  <v-btn class="ml-2 mb-2" color="primary" @click="removeSelectedProducts" :disabled="itemsDelete">{{ $t('message.common.delete') }}</v-btn>
                </v-col>
                <v-col cols="4" sm="3" md="2" class="pa-0" v-if="supplierObj.supplierid && !disableFormFields" @click="addProductsToList">
                  <v-btn class="ml-2 mb-2" color="primary" :loading="loadingSupplierProducts">{{ $t('message.whOrder.orderProposal') }}</v-btn>
                </v-col>
                <v-col cols="4" sm="3" md="2" class="pa-0" v-if="supplierObj.supplierid && !disableFormFields">
                  <v-checkbox dense color="primary" hide-details v-model="isMainSupplier" :label="$t('message.order.asMainSupplier')"></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="1" class="text-right mt-2">
              <v-btn fab x-small color="primary" v-if="showScrollToBottom" @click="goToBottom"><v-icon>mdi-chevron-down</v-icon></v-btn>
            </v-col>
          </v-row>
          <v-simple-table dense class="order_item_table mt-2">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">#</th>
                  <th>
                    {{ $t('message.warehouse.product') }}*
                    <v-progress-circular v-if="loadingProducts" indeterminate color="primary"></v-progress-circular>
                  </th>
                  <th> {{ $t('message.product.unit') }} </th>
                  <th>{{ $t('message.whOrder.orderQty') }}*</th>
                  <th class="text-right">{{ $t('message.whOrder.minQty') }}</th>
                  <th class="text-right">{{ $t('message.whOrder.availQty') }}</th>
                  <th class="text-right">{{ $t('message.whOrder.orderedQty') }}</th>
                  <th class="text-right">{{ $t("message.whOrder.unitCost") }}</th>
                  <th v-if="supplierObj.status === 'inprogress' || supplierObj.status === 'received' || supplierObj.status === 'partiallyreceived'">{{ $t('message.layout.location') }}*</th>
                  <th v-if="supplierObj.status !== 'ordered' && supplierObj.status !== 'draft'">{{ $t('message.whOrder.recQty') }}</th>
                  <th v-if="supplierObj.status !== 'ordered' && supplierObj.status !== 'draft'">
                    {{ $t('message.orders.restQty') }}
                  </th>
                  <th v-if="supplierObj.status !== 'ordered' && supplierObj.status !== 'draft'">
                    {{ $t('message.order.batchNo') }}
                    <v-progress-circular v-if="loadingBatchNumber" indeterminate color="primary"></v-progress-circular>
                  </th>
                  <th class="text-right">{{ $t('message.common.total') }}</th>
                  <th v-if="supplierObj.status !== 'ordered' && supplierObj.status !== 'draft'">{{ $t('message.whOrder.expireDate') }}</th>
                  <th>{{ $t('message.common.comments') }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(element, index) in orderItems" :key="index" class="pt-4">
                  <v-text-field type="text" class="hidden-sm-and-up hidden-sm-and-down" v-model="element.id"></v-text-field>
                  <td width="3%">
                    <v-checkbox dense hide-details color="primary" v-model="element.isSelected" class="mt-0 pa-0"></v-checkbox>
                  </td>
                  <td width="18%" class="alignSub pr-0 pl-0">
                    <template v-if="element.olditem ? element.olditem.productid : false">
                      {{ element.productnumber || '-' }} {{ element.productname || '-' }}
                    </template>
                    <v-autocomplete v-else v-model="element.productid" :items="element.products" autocomplete="off"
                    @keyup="$event.keyCode !== 13 &&  $event.keyCode !== 9 ? loadProducts(`searchInput${index}`, index, $event) : ''"
                    :ref="`searchInput${index}`" outlined dense
                    @click="toggleAllProducts(index, SHOW)"
                    @focusout="toggleAllProducts(index, HIDE, element.productid)"
                    @change="getActiveProuct(index, element.productid)"
                    item-text="productName" item-value="id" :rules="$_requiredValidation" :disabled="disableFormFields"
                    hide-details :placeholder="$t('message.common.typeHere')" :loading="element.productLoader"></v-autocomplete>
                  </td>
                  <td width="6%" class="alignSub pr-0 pl-1">
                      <v-autocomplete @change="unitCalculation(index)" outlined dense :items="listOfUnitMatrix.filter(x => x.productid === element.productid && x.issupplier)" item-text="productunit_name" autocomplete="off" :rules="$_requiredValidation" v-model="element.unitid"
                      item-value="id" @click:clear="$nextTick(() => element.unitid = null)" ref="unitid" hide-details :disabled="['partiallyreceived', 'received'].includes(supplierObj.status)"></v-autocomplete>
                  </td>
                  <td width="6%" class="alignSub pr-0 pl-1">
                    <v-text-field v-model="element.qty" :disabled="supplierObj.status === 'received'" outlined dense  :ref="`qty_${index}`"
                      :rules="element.qty ? $_norwegianNumberValidation : $_requiredValidation" hide-details
                      @keyup="$event.keyCode !== 13 &&  $event.keyCode !== 9 ? checkReceivedQty(index, element.qty): ''" @change="calculateTotalValue(index)" @blur="qtyChanged ? autoSave () : ''"
                      :placeholder="$t('message.common.typeHere')"></v-text-field>
                  </td>
                  <td width="5%" class="alignSub text-right pr-0 pl-1">
                    {{ element.minqty }}
                  </td>
                  <td width="5%" class="alignSub text-right pr-0 pl-1">
                    {{ element.available }}
                  </td>
                  <td class="alignSub text-right pr-0 pl-1">
                    {{ element.orderedqty }}
                  </td>
                  <td width="7%" class="alignSub text-right pr-0 pl-1">
                    <v-text-field v-model="element.discountedprice" outlined dense :disabled="userDetails.role_id != 1"
                      :rules="element.discountedprice ? $_norwegianNumberValidation : []" hide-details
                      @click="showEditUnitCostPopup(index)"
                      ></v-text-field>
                  </td>
                  <td width="10%" class="alignSub pr-0 pl-1" v-if="supplierObj.status === 'inprogress' || supplierObj.status === 'received' || supplierObj.status === 'partiallyreceived'">
                    <template v-if="!element.custmerordermaterialid">
                      <template v-if="element.receivedorders && element.receivedorders.length > 0">
                        <div v-for="(item) in element.receivedorders" :key="item.id">
                          <v-autocomplete outlined dense v-model="item.locationid" :rules="item.receivedqty ? $_requiredValidation : []"
                            :items="item.listOfLocation"
                            item-text="name" item-value="id" class="mt-1" autocomplete="off" disabled
                            hide-details :placeholder="$t('message.common.typeHere')">
                          </v-autocomplete>
                        </div>
                      </template>
                        <v-autocomplete v-model="element.locationid" :items="element.listOfLocation" autocomplete="off"  class="mt-1"
                          @keyup="$event.keyCode !== 13 ? getWarehouseLocations(`searchLocation${index}`, index, $event, supplierObj.warehouseid) : ''"
                          :ref="`searchLocation${index}`" outlined dense
                          @click="toggleLocations(index, SHOW)"
                          v-if="supplierObj.status !== 'received' && !element.isMaximumUsed"
                          @focusout="toggleLocations(index, HIDE, element.locationid)"
                          item-text="name" item-value="id"
                          :rules="element.receivedqty ? $_requiredValidation : []"
                          :loading="element.locationLoading"
                          hide-details :placeholder="$t('message.order.searchLocation')">
                          <template v-slot:no-data>
                            <span class="pa-1 caption">{{ $t('message.common.noResults') }}</span>
                          </template>
                        </v-autocomplete>
                      <!-- <v-autocomplete class="mt-1" outlined dense v-model="element.locationid" :rules="element.receivedqty ? $_requiredValidation : []" :items="element.listOfLocation"
                        item-text="name" item-value="id" autocomplete="off"  @change="changesMade()"
                        hide-details :placeholder="$t('message.common.typeHere')"
                        v-if="supplierObj.status !== 'received' && !element.isMaximumUsed"></v-autocomplete> -->
                    </template>
                  </td>
                  <td v-if="supplierObj.status !== 'ordered' && supplierObj.status !== 'draft'" width="7%" class="alignSub pr-0 pl-1">
                    <template v-if="element.receivedorders && element.receivedorders.length > 0">
                      <div v-for="(item) in element.receivedorders" :key="item.id">
                        <v-text-field outlined dense hide-details class="mb-1" v-model="item.receivedqty" disabled></v-text-field>
                      </div>
                    </template>
                    <v-text-field class="mb-1" outlined dense v-if="supplierObj.status !== 'received' && !element.isMaximumUsed"
                      @change="validateQtyHandler(index, element.qty)" v-model="element.receivedqty" hide-details :placeholder="$t('message.common.typeHere')"
                      :rules="element.locationid ? $_requiredValidation : element.receivedqty ? $_norwegianNumberValidation : []"></v-text-field>
                  </td>
                  <td v-if="supplierObj.status !== 'ordered' && supplierObj.status !== 'draft'" width="6%" class="alignSub pr-0 pl-1">
                    {{ element.restqty | replaceDotWithComma }}
                  </td>
                  <td v-if="supplierObj.status !== 'ordered' && supplierObj.status !== 'draft'" width="9%" class="alignSub pr-0 pl-1">
                    <template v-if="element.isbatch">
                      <template v-if="element.receivedorders && element.receivedorders.length > 0">
                        <div v-for="(item) in element.receivedorders" :key="item.id">
                          <v-text-field outlined dense hide-details class="mb-1" v-model="item.batchnumber" disabled></v-text-field>
                        </div>
                      </template>
                      <v-text-field class="mb-1" outlined dense v-if="supplierObj.status !== 'received' && !element.isMaximumUsed"
                        v-model="element.batchnumber" hide-details :placeholder="$t('message.common.typeHere')" :rules="element.receivedqty ? $_requiredValidation : []"></v-text-field>
                    </template>
                  </td>
                  <td width="9%" class="alignSub text-right pr-0 pl-1">
                    {{ element.totalprice | replaceDotWithComma }} {{ element.suppliercurrency || '' }}
                  </td>
                  <td width="14%" v-if="supplierObj.status !== 'ordered' && supplierObj.status !== 'draft'" class="alignSub pr-0 pl-1">
                    <template v-if="element.receivedorders && element.receivedorders.length > 0">
                      <div v-for="(item) in element.receivedorders" :key="item.id">
                        <v-text-field outlined dense hide-details class="mb-1" v-model="item.expirydate" disabled></v-text-field>
                      </div>
                    </template>
                    <v-menu :close-on-content-click="false" v-model="element.expireMenu" transition="scale-transition"
                      offset-y min-width="290px" v-if="supplierObj.status !== 'received' && !element.isMaximumUsed">
                      <template v-slot:activator="{ on }">
                        <v-text-field outlined hide-details dense clearable
                        v-on="on" v-model="element.expirydate"
                        @click:clear="$nextTick(() => element.expireDatePicker = null)"></v-text-field>
                      </template>
                      <v-date-picker color="primary" v-model="element.expireDatePicker"
                      @change="element.expirydate = $formatter.formatDate(element.expireDatePicker, 'YYYY-MM-DD', 'DD.MM.YYYY')"
                      @input="element.expireMenu = false" first-day-of-week='1'></v-date-picker>
                    </v-menu>
                  </td>
                  <td width="20%" class="alignSub">
                    <v-text-field outlined dense v-model="element.comments" type="text" :disabled="disableFormFields" hide-details :placeholder="$t('message.common.typeHere')"></v-text-field>
                  </td>
                  <td class="alignSub pr-0 pl-1" v-if="supplierObj.status !== 'partiallyreceived' && supplierObj.status !== 'received'">
                    <v-btn class="mx-2" text fab dark small color="primary" @click="deleteProductRow(index, element.id)">
                      <v-icon dark>mdi-minus-circle</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-form>
        <v-btn class="mx-2" fab dark small color="primary" @click="addProductRowHandler" v-if="supplierObj.supplierid && !disableFormFields">
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
        <v-fab-transition>
          <v-btn fab bottom right color="primary" id="scroll__top" fixed v-if="showScrollToTop" @click="scrollToTop">
            <v-icon dark>mdi-chevron-up</v-icon>
          </v-btn>
        </v-fab-transition>
        <!-- Picking qty is greater than ordered -->
        <v-dialog v-model="moreQtyObj.dialog" persistent width="400">
          <v-card>
            <v-card-title class="headline grey lighten-2" primary-title> {{ $t('message.common.warning') }} </v-card-title>
            <v-card-text class="pa-5">
              <h4>{{ $t('message.order.orderedQtyHigh') }}</h4>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="moreQtyObj.onSuccess">{{ $t('message.common.yes') }} </v-btn>
              <v-btn color="error" @click="moreQtyObj.onCancel">{{ $t('message.common.no') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Delete order items -->
        <v-dialog v-model="deleteObj.dialog" persistent max-width="400px" class="mt-0">
          <v-card>
            <v-card-title>
              {{ $t('message.common.deleteConfirm') }}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-5">
              {{ $t('message.common.areYouSure') }}
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" id="deleteConfirm" @click="deleteObj.onSuccess">{{ $t('message.common.yes') }}</v-btn>
              <v-btn color="primary" id="deleteClose" @click="deleteObj.onClose">{{ $t('message.common.no') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="supplierDialog" width="800" persistent>
          <form-data :references.sync="supplierItemsReference" :model="supplierModel" ref="costItemReference"></form-data>
        </v-dialog>
      </template>
    </form-data>
    <div id="noso_products" style="visibility: hidden;"></div>
    <v-dialog v-model="attachmentsDialog" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title>{{ $t('message.product.attachments') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              icon
              dark
              @click="attachmentsDialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <document-manager class="pa-1 custom-max-width" :modelObj.sync="supplierObj" :module="SP_SUPPLIER_ORDER" :key="reInit" :hidecreate="true"></document-manager>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
/* eslint-disable */
import { mapState } from 'vuex'
import FormTemplate from '@/components/FormTemplate'
import goTo from 'vuetify/lib/services/goto'
import CONSTANTS from '@/utils/warehouse.json'
export default {
  data () {
    return {
      totalPriceLoading: false,
      supplierDialog: false,
      supplierLoading: false,
      selectedProduct: {},
      supplierModel: {
        supplierprice: '',
        supplierdiscount: '',
        discounted: '',
        shipmentaddon: '',
        other: '',
        realcost: '',
        realcostnok: '',
        currencyid: '',
        ismain: true
      },
      listOfUnitMatrix: [],
      listOfCurrencyList: [],
      totalExchangeAmount: 0,
      supplierTransformList: ['supplierprice', 'supplierdiscount', 'discounted', 'shipmentaddon', 'other', 'realcost', 'realcostnok'],
      supplierObj: {
        id: this.$route.params.supp_id,
        file: [],
        status: 'draft',
        priority: 'medium',
        datePicker: '',
        dateesPicker: ''
      },
      fieldsLoading: false,
      loading: false,
      orderItems: [],
      listOfProducts: [],
      listOfLocation: [],
      orderAttachment: [],
      disableFormFields: false,
      disableStatusChange: false,
      listOfAllProducts: [],
      loadingProducts: false,
      loadingBatchNumber: false,
      loadingSupplierProducts: false,
      moreQtyObj: {
        dialog: false
      },
      totalPrice: 0,
      supplierCurrency: '',
      lastUpdated: '',
      lastUpdatedShow: false,
      isMainSupplier: true,
      deleteObj: {
        dialog: false
      },
      canReloadDocument: false,
      reInit: 0,
      isAutoSave: false,
      attachmentsDialog: false,
      attachmentsCount: 0,
      attachmentsCountLoading: false,
      qtyChanged: false,
      receiveAllLoader: false,
      showScrollToTop: false,
      showScrollToBottom: false
    }
  },
  components: {
    'form-data': FormTemplate,
    'document-manager': () => import('@/components/Documents/ModulesDocuments')
  },
  created () {
    this.getAllCurrencyList()
    this.getAllProductUnitMatrices()
  },
  computed: {
    ...mapState(['FORM_TYPE', 'listOfSuppliers', 'listOfWarehouse', 'listOfLocations', 'userDetails', 'listOfUsers']),
    isItemsSelectedForDelete () {
      return this.orderItems.filter(x => x.isSelected).length >= 1
    },
    pageHeight () {
      return document.body.scrollHeight
    },
    itemsDelete () {
      return this.orderItems.some(x => x.isSelected && x.receivedorders && x.receivedorders.some(y => y.locationid))
    },
    supplierItemsReference () {
      return {
        title: this.supplierModel.id ? this.$t('message.product.updateSupplierItem') : this.$t('message.product.addSupplierItem'),
        properties: [
          {
            model: 'supplierid',
            type: this.FORM_TYPE.AUTO_COMPLETE,
            rules: this.$_requiredValidation,
            label: this.$t('message.order.supplier'),
            items: this.listOfSuppliers,
            select_text: 'name',
            select_value: 'id',
            disabled: true,
            class: 'lg4 sm6'
          },
          {
            model: 'articlenumber',
            type: this.FORM_TYPE.TEXT,
            rules: this.$_requiredValidation,
            label: this.$t('message.product.articleNumber'),
            class: 'lg4 sm6'
          }, {
            model: 'articlename',
            type: this.FORM_TYPE.TEXT,
            rules: this.$_requiredValidation,
            label: this.$t('message.product.articleName'),
            class: 'lg4 sm6'
          }, {
            model: 'currencyid',
            type: this.FORM_TYPE.AUTO_COMPLETE,
            rules: this.$_requiredValidation,
            label: this.$t('message.product.currency'),
            items: this.listOfCurrencyList,
            select_text: 'name',
            select_value: 'id',
            class: 'lg3 sm6',
            change: this.getCurrencyExAmount
          }, {
            model: 'supplierprice',
            type: this.FORM_TYPE.TEXT,
            rules: this.$_norwegianNumberValidation,
            label: this.$t('message.product.supplierPrice'),
            change: this.calculateDiscounted,
            class: 'lg3 sm6'
          }, {
            model: 'supplierdiscount',
            type: this.FORM_TYPE.TEXT,
            rules: this.$_discountValidation,
            label: this.$t('message.product.supplierDiscount'),
            change: this.calculateDiscounted,
            class: 'lg2 sm6'
          }, {
            model: 'discounted',
            type: this.FORM_TYPE.TEXT,
            rules: this.$_norwegianNumberValidation,
            label: this.$t('message.product.discounted'),
            change: this.calculateRealCost,
            class: 'lg2 sm6'
          }, {
            model: 'other',
            loading: this.priceLoading,
            type: this.FORM_TYPE.TEXT,
            rules: this.$_norwegianNumberValidation,
            label: this.$t('message.product.other'),
            change: this.calculateRealCost,
            class: 'lg2 sm6'
          }, {
            model: 'shipmentaddon',
            type: this.FORM_TYPE.TEXT,
            loading: this.priceLoading,
            rules: this.$_norwegianNumberValidation,
            label: this.$t('message.product.shipmentAddon'),
            change: this.calculateRealCost,
            class: 'lg3 sm6'
          }, {
            model: 'realcost',
            type: this.FORM_TYPE.TEXT,
            rules: this.$_norwegianNumberValidation,
            label: this.$t('message.product.realCost'),
            class: 'lg3 sm6',
            change: this.calculateRealCost
          }, {
            model: 'realcostnok',
            type: this.FORM_TYPE.TEXT,
            loading: this.totalPriceLoading,
            rules: this.$_norwegianNumberValidation,
            label: this.$t('message.product.realCostNOK'),
            class: 'lg3 sm6'
          }, {
            model: 'ismain',
            rules: [],
            type: this.FORM_TYPE.CHECKBOX,
            class: 'lg3 sm6 pt-0 pb-0',
            label: this.$t('message.product.isMain')
          }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.supplierModel.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: () => this.saveUpdateSupplierItemHandler(),
          loading: this.supplierLoading,
          is_show: true
        }, {
          name: 'close',
          color: 'info',
          click: () => this.closeAddNewSupplier(),
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    },
    statusList () {
      if (!this.$route.params.supp_id || !this.supplierObj.id) {
        return [{
          name: this.$t('message.common.draft'), id: CONSTANTS.DRAFT
        }]
      } else if (this.supplierObj.status !== CONSTANTS.RECEIVED && this.supplierObj.status !== CONSTANTS.PARTIALLYRECEIVED) {
        return [{
          name: this.$t('message.common.draft'), id: CONSTANTS.DRAFT
        }, {
          name: this.$t('message.common.ordered'), id: CONSTANTS.ORDERED
        }, {
          name: this.$t('message.common.inProgress'), id: CONSTANTS.INPROGRESS
        }]
      } else {
        return [{
          name: this.$t('message.common.received'), id: CONSTANTS.RECEIVED
        }, {
          name: this.$t('message.common.partiallyReceived'), id: CONSTANTS.PARTIALLYRECEIVED
        }]
      }
    },
    formReferences () {
      return {
        title: this.$route.params.supp_id ? `${this.$t('message.whOrder.updateSupplierOrder')} (${this.supplierObj.number || ''})` : this.$t('message.whOrder.addSupplierOrder'),
        properties: [{
          model: 'orderdate',
          rules: this.$_requiredValidation,
          type: this.FORM_TYPE.DATEPICKER,
          class: 'lg2 sm6 xs12',
          picker: 'datePicker',
          menu: 'dateMenu',
          color: 'primary lighten-1',
          disabled: this.disableFormFields,
          label: this.$t('message.whOrder.orderDate'),
          change: this.changesMade
        }, {
          model: 'supplierid',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: this.$_requiredValidation,
          items: this.listOfSuppliers,
          term: 'supplier',
          click: (term) => null,
          is_list: false,
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.order.supplier'),
          class: 'lg3 sm6',
          disabled: this.disableFormFields,
          // change: this.autoSave
          change: this.findSupplierName
        }, {
          model: 'warehouseid',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          disabled: this.disableFormFields,
          rules: this.$_requiredValidation,
          items: this.listOfWarehouse,
          click: (term) => null,
          is_list: false,
          term: '',
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.layout.warehouse'),
          class: 'lg2 sm6',
          change: this.changesMade
        }, {
          model: 'priority',
          type: this.FORM_TYPE.SELECT,
          disabled: this.disableFormFields,
          rules: [],
          items: this.$_priorityList,
          term: '',
          is_list: true,
          select_text: 'text',
          select_value: 'value',
          label: this.$t('message.layout.priority'),
          class: 'lg2 sm6',
          change: this.changesMade
        }, {
          model: 'estimated_date',
          rules: [],
          type: this.FORM_TYPE.DATEPICKER,
          disabled: this.disableFormFields,
          class: 'lg2 sm6 xs12',
          picker: 'dateesPicker',
          menu: 'dateesMenu',
          color: 'primary lighten-1',
          label: this.$t('message.whOrder.estimated'),
          change: this.changesMade
        }, {
          model: 'custom_fields',
          class: 'lg12 xs12'
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.$route.params.supp_id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: () => this.saveWithoutAuto(this.SAVE),
          loading: this.loading,
          is_show: true
        }, {
          name: 'action_handler_update',
          color: 'primary',
          label: this.$t('message.common.updateAndClose'),
          click: () => this.saveWithoutAuto(this.UPDATE_CLOSE),
          loading: this.loading,
          is_show: this.$route.params.supp_id
        }, {
          name: 'back_to_list',
          color: 'info',
          // eslint-disable-next-line
          click: () => this.$router.push('/w_h/order'),
          label: this.$t('message.common.backToList'),
          to: '/w_h/order',
          is_show: true
        }, {
          name: 'delete_btn',
          color: 'error',
          label: this.$t('message.common.delete'),
          click: this.deleteHandler,
          disabled: this.disableStatusChange,
          is_show: this.$route.params.supp_id
        }],
        end_buttons: [{
          name: 'print',
          color: 'success',
          click: () => this.$parent.$parent.donwloadPrintedProducts({ ...this.supplierObj, type_ref: 'supplier' }),
          loading: false,
          label: this.$t('message.product.print'),
          class: 'text-right',
          is_show: this.supplierObj.id && this.$route.params.supp_id
        }, {
          name: 'download',
          color: 'teal',
          click: () => this.$parent.$parent.printOrder({ ...this.supplierObj, type_ref: 'supplier' }),
          loading: false,
          label: this.$t('message.order.download'),
          class: 'text-right',
          is_show: this.supplierObj.id && this.$route.params.supp_id
        }, {
          name: 'share',
          color: 'info',
          label: this.$t('message.order.share'),
          click: () => this.$parent.$parent.sendReport({ ...this.supplierObj, type_ref: 'supplier' }),
          loading: false,
          class: 'text-right',
          is_show: this.supplierObj.id && this.$route.params.supp_id
        }]
      }
    }
  },
  mounted () {
    this.supplierObj.orderdate = this.$formatter.formatDate(new Date(), 'YYYY-MM-DD', 'DD.MM.YYYY')
    this.isAutoSave = this.$route.query.autosave
    if (this.supplierObj.id) {
      this.getSingleRecordHandler()
      window.history.pushState({ path: this.$route.path }, '', this.$route.path)
    } else {
      if (this.userDetails.id && this.userDetails.id !== -100) {
        this.supplierObj.responsible = this.userDetails.id
      }
    }
    let text = this.$t('message.common.deleteSuccess')
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.ORDERITEMS) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        if (!data.orderItemsAutoSave) this.getSingleRecordHandler()
      } else if (data !== 'sharepoint') {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.$store.commit('isChangesMade', false)
        this.$router.push('/w_h/order')
      }
    })
    // read supporting list items
    this.$store.dispatch('getSupplierList')
    this.$store.dispatch('getUsers')
    this.$store.dispatch('getWarehouse')
      .then(() => {
        if (!this.supplierObj.id) this.setDefaultValues({ prop: 'warehouseid', list: this.listOfWarehouse })
      })
    // this.$store.dispatch('getWarehouseLocations')
    this.supplierObj.type = this.SUPPLIERORDER
    this.$root.$on('reloadOrderDetails', () => {
      if (this.supplierObj.id) this.getSingleRecordHandler()
    })
    /* Load if sharepoint_id not set */
    this.$root.$on('get_supplierorder_details', () => {
      this.canReloadDocument = true
      this.getSingleRecordHandler()
    })
    /* --- */
  },
  watch: {
    'supplierObj.datePicker' (val) {
      if (val) {
        this.supplierObj.orderdate = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    },
    'supplierObj.dateesPicker' (val) {
      if (val) {
        this.supplierObj.estimated_date = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    },
    'supplierObj.supplierid' (val) {
      if (val) {
        this.orderItems = []
        this.addProductRowHandler()
      }
    },
    'supplierObj.warehouseid' (val) {
      if (val) {
        this.getLocation(val)
      } else {
        this.listOfLocation = []
        this.clearLocationRefForWarehouse()
      }
    },
    'supplierObj.status' (val) {
      if (!val || val === CONSTANTS.DRAFT) this.disableFormFields = false
      else this.disableFormFields = true
    }
  },
  methods: {
    autoSave () {
      if (this.orderItems.length >= 1) {
        let canSave = true
        this.orderItems.every((element) => {
          if (!element.productid && !element.qty) {
            canSave = false
            return false
          } else return true
        })
        if (canSave) {
          this.qtyChanged = false
          this.saveUpdateHandler(this.SAVE, true)
        }
      }
    },
    saveWithoutAuto (type) {
      setTimeout(() => {
        if (!this.loading) this.saveUpdateHandler(type)
      }, 300)
    },
    getAllProductUnitMatrices () {
      let query = {
        expand: [{
          model: 'ProductUnit',
          on_field: 'id',
          on_parent_field: 'unitid'
        }]
      }
      this.$_executeApi('post', `productunitmatrix/query`, query)
        .then((response) => {
          this.listOfUnitMatrix = response.data
        })
    },
    getAllCurrencyList () {
      this.$_executeApi('get', `currencies/get_all_currency_list`)
        .then((response) => {
          response.data.sort((a, b) => a.name.localeCompare(b.name))
          this.listOfCurrencyList = response.data
        })
    },
    showEditUnitCostPopup (index) {
      let orders = this.orderItems
      if (orders[index]) {
        this.supplierModel.supplierid = this.$route.params.supp_id
        this.selectedProduct = orders[index]
        let productid = this.selectedProduct.productid
        let supplierid = this.supplierObj.supplierid
        if (productid) {
          this.$_executeApi('get', `productsuppliers/${productid}/${supplierid}`)
            .then((response) => {
              let transformData = { number: { list: this.supplierTransformList, format: 'replaceDotWithComma' } }
              let model = this.$_formatModel(response.data, transformData)
              if (model.id) {
                this.initStage = true
                this.supplierModel = model
                setTimeout(() => {
                  this.initStage = false
                }, 100)
                this.supplierDialog = true
                this.getCurrencyExAmount()
              }
            })
        }
      }
    },
    closeAddNewSupplier () {
      this.supplierDialog = false
    },
    saveUpdateSupplierItemHandler () {
      if (this.$refs.costItemReference.$refs.validateForm.validate()) {
        this.supplierLoading = true
        let transformData = { number: { list: this.supplierTransformList, format: 'replaceCommaWithDot' } }
        let model = this.$_formatModel(this.supplierModel, transformData)
        this.$_saveUpdateHandler('productsuppliers', model)
          .then((response) => {
            if (model.ismain) this.$eventBus.$emit('updatedSupplier', model)
            this.closeAddNewSupplier()
            if (this.supplierObj.id) this.getOrderItemsHandler(this.supplierObj.id)
          })
          .finally(() => {
            this.supplierLoading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    calculateDiscounted () {
      let price = this.supplierModel.supplierprice ? this.$formatter.replaceCommaWithDot(this.supplierModel.supplierprice) : 0
      let discount = this.supplierModel.supplierdiscount ? this.$formatter.replaceCommaWithDot(this.supplierModel.supplierdiscount) : 0
      let total = price * (100 - discount) / 100
      this.supplierModel.discounted = isNaN(total) ? 0 : this.$formatter.replaceDotWithComma(total)
      this.calculateRealCost()
    },
    async calculateRealCost () {
      if (!this.initStage) {
        let discounted = this.supplierModel.discounted ? this.$formatter.replaceCommaWithDot(this.supplierModel.discounted) : 0
        let shipmentaddon = this.supplierModel.shipmentaddon ? this.$formatter.replaceCommaWithDot(this.supplierModel.shipmentaddon) : 0
        let other = this.supplierModel.other ? this.$formatter.replaceCommaWithDot(this.supplierModel.other) : 0
        let total = +discounted * (+other + 100) / 100 * (+shipmentaddon + 100) / 100
        this.supplierModel.realcost = isNaN(total) ? 0 : this.$formatter.replaceDotWithComma(total)
        this.supplierModel.realcostnok = isNaN(total) ? 0 : this.$formatter.replaceDotWithComma(total * this.totalExchangeAmount)
      }
    },
    getCurrencyExAmount () {
      if (this.supplierModel.currencyid) {
        this.totalPriceLoading = true
        this.$_executeApi('get', `/currencies/get_exchange_rate/${this.supplierModel.currencyid}`)
          .then((response) => {
            this.totalPriceLoading = false
            this.totalExchangeAmount = response.data
            this.calculateRealCost()
          })
      }
    },
    clearLocationRefForWarehouse () {
      let productItems = this.$formatter.cloneVariable(this.orderItems)
      for (let i = 0; i < productItems.length; i++) {
        let productItem = productItems[i]
        productItem.locationid = null
        this.$set(this.orderItems, i, productItem)
      }
    },
    addProductRowHandler () {
      let getLocation = this.getLocationDefaultValue({ list: this.listOfLocation, warehouseid: this.supplierObj.warehouseid })
      this.orderItems.push({ products: [], locationid: getLocation ? getLocation.id : 0, isSelected: false })
    },
    // Searching products
    loadProducts (term, index, event) {
      if ([32, 37, 38, 39, 40, 30].indexOf(event.keyCode) > -1) return
      let searchText = this.$refs[term][0].lazySearch
      if (searchText) {
        this.$set(this.orderItems, index, { ...this.orderItems[index], productLoader: true })
        this.$_executeApi('get', `productpackages/get_supplierproducts_packages?supplierid=${this.supplierObj.supplierid}&search_term=${searchText}`).then((response) => {
          this.orderItems[index].products = []
          if (response.data.length > 0) {
            response.data.forEach(element => {
              element.productName = element.productnumber ? `${element.productnumber} - ${element.productname}` : element.productname
              element.id = element.productid
            })
            this.orderItems[index].products = response.data
          }
        }).finally(() => {
          this.$set(this.orderItems, index, { ...this.orderItems[index], productLoader: false })
        })
      }
    },
    getLocation (id) {
      // let query = {
      //   select: ['id', 'name', 'warehouseid', 'isdefault'],
      //   filter: `isactive eq 1 and warehouseid eq ${id}`,
      //   'order_by': {
      //     'field': 'name',
      //     'asc_or_desc': 'asc'
      //   }
      // }
      this.clearLocationRefForWarehouse()
      // this.$_executeApi('post', 'warehouselocations/query', query).then(response => {
      //   this.listOfLocation = response.data
      //   let productItems = this.$formatter.cloneVariable(this.orderItems)
      //   let getLocation = this.getLocationDefaultValue({ list: this.listOfLocation, warehouseid: id })
      //   for (let i = 0; i < productItems.length; i++) {
      //     if (!productItems[i].locationid) {
      //       let productItem = this.orderItems[i]
      //       productItem.locationid = getLocation ? getLocation.id : 0
      //       this.$set(this.orderItems, i, productItem)
      //     }
      //   }
      // })
    },
    getWarehouseLocations (term, index, event, warehouseid) {
      if ([32, 37, 38, 39, 40, 30].indexOf(event.keyCode) > -1) return
      let searchText = this.$refs[term][0].lazySearch
      if (searchText !== null) {
        let query = {
          select: ['id', 'name', 'warehouseid', 'isdefault'],
          additionalfilters: [`name contains  '${searchText}'`],
          skip: 0,
          limit: 50,
          filter: `isactive eq 1 and warehouseid eq ${warehouseid}`,
          'order_by': {
            'field': 'name',
            'asc_or_desc': 'asc'
          }
        }
        this.$set(this.orderItems, index, { ...this.orderItems[index], locationLoading: true })
        this.$_executeApi('post', 'warehouselocations/query', query).then((response) => {
          let currentItem = this.orderItems[index]
          currentItem.listOfLocation = response.data
          this.$set(this.orderItems, index, currentItem)
        }).finally(() => {
          this.$set(this.orderItems, index, { ...this.orderItems[index], locationLoading: false })
        })
      }
    },
    toggleLocations (index, action, locationid) {
      // this.$parent.$parent.toggleAllLocations(index, actions, locationid)
      let items = this.$formatter.cloneVariable(this.orderItems)
      if (action === this.HIDE && items[index] && items[index].listOfLocation) {
        let locations = items[index].listOfLocation.filter(x => x.id === locationid)
        items[index].listOfLocation = locations
      }
      if (this.orderItems && this.orderItems.length > 0 && this.orderItems[index]) this.$set(this.orderItems, index, items[index])
    },
    getSingleRecordHandler (autoSave, restrictOrderItems) {
      if (!autoSave || !this.isAutoSave) this.fieldsLoading = true
      let query = {
        expand: [{
          model: 'User',
          on_field: 'id',
          on_parent_field: 'updatedby'
        }],
        filter: `id eq ${this.supplierObj.id}`
      }
      this.$_executeApi('post', `${this.WH_ORDER}/query`, query)
        .then((result) => {
          if (result.data) {
            let transformDate = { date: { list: ['orderdate', 'estimated_date'], from: 'DD-MM-YYYYTHH:mm:ss', to: 'DD.MM.YYYY' } }
            let model = this.$_formatModel(result.data[0], transformDate)
            this.supplierObj = model
            let supplier = this.listOfSuppliers.find(x => x.id === this.supplierObj.supplierid)
            if (supplier) this.supplierObj.supplier_name = supplier.name
            if (this.supplierObj.sharepoint_id) this.getChildrenCount(this.supplierObj.sharepoint_id)
            if (this.supplierObj.status === CONSTANTS.RECEIVED || this.supplierObj.status === CONSTANTS.PARTIALLYRECEIVED) this.disableStatusChange = true
            if (!restrictOrderItems) this.getOrderItemsHandler(this.supplierObj.id, this.isAutoSave)
            this.getSupplierInformation()
            let user = ''
            if (model && this.$route.params.supp_id) {
              this.lastUpdatedShow = true
              user =
              model.updatedby === -100
                ? 'SuperAdmin'
                : `${model.user_name || ''}`
            }
            this.lastUpdated = `${
              model && model.updatedon
                ? `${user || ''}, ${this.$formatter.formatDate(
                  model.updatedon,
                  'DD.MM.YYYY HH:mm:ss',
                  'DD.MM.YYYY HH:mm:ss'
                )}`
                : ''
            }`
            /*  */
            if (this.canReloadDocument) this.reInit++
            this.canReloadDocument = false
          }
        })
    },
    getSupplierInformation () {
      let query = {
        expand: [{
          'model': 'CustomerAddress',
          'on_field': 'customer_id',
          'on_parent_field': 'id'
          // 'filter': `isstandard eq 1`
        }],
        filter: `id eq '${this.supplierObj.supplierid}'`,
        'limit': 1
      }
      this.$_executeApi('post', 'customers/query', query)
        .then(response => {
          if (response && response.data && response.data[0]) {
            // eslint-disable-next-line camelcase
            const { email, language, name, customeraddress_address, customeraddress_address2, customeraddress_postcode, customeraddress_city, customeraddress_country } = response.data[0]
            const getType = this.$_orderType.find(x => x.value === this.supplierObj.type)
            const type = getType ? getType.text : this.supplierObj.type
            let model = {
              supplier_email: email,
              supplier_language: language,
              supplier_name: name,
              type,
              supplier_address: customeraddress_address,
              supplier_address2: customeraddress_address2,
              supplier_postcode: customeraddress_postcode,
              supplier_city: customeraddress_city,
              supplier_country: customeraddress_country
            }
            this.supplierObj = Object.assign({ ...this.supplierObj }, { ...model })
          }
        })
    },
    getOrderItemsHandler (id, autoSave) {
      let url = `warehouseorderitems/get_by_order/${id}`
      this.$_executeApi('get', url)
        .then((response) => {
          let data = response.data
          let items = []
          data.forEach((element, index) => {
            element.products = []
            element.products.push({
              id: element.productid,
              productName: element.productnumber ? `${element.productnumber} - ${element.productname}` : element.productname
            })
            element.orderedqty = element.qty * element.unitqty
            if (element.qty === element.receivedqty || element.qty < element.receivedqty) element.isMaximumUsed = true
            else element.isMaximumUsed = false
            if (this.supplierObj.status !== 'received') element.receivedqty = ''
            let receivedRef = 0
            if (element.receivedorders) {
              element.receivedorders.map(recElement => {
                recElement.listOfLocation = [{
                  id: recElement.locationid,
                  name: recElement.locationname
                }]
                receivedRef += recElement.receivedqty
                recElement.receivedqty = this.$formatter.replaceDotWithComma(recElement.receivedqty)
                recElement.expirydate = recElement.expirydate ? this.$formatter.formatDate(recElement.expirydate, 'DD.MM.YYYY', 'DD.MM.YYYY') : ''
                return recElement
              })
              element.receivedRef = receivedRef
              // get rest_qty value
              let allItems = element.receivedorders
              let getTotal = this.$_getSumBy(allItems, x => x.receivedqty)
              var getRestQty = (element.qty - getTotal)
              element.restqty = getRestQty || 0
            }

            if (element.receivedRef !== element.qty) {
              element.receivedqty = ''
              element.locationid = 0
              element.isSelected = false
              element.olditem = this.$formatter.cloneVariable(element)
              items.push(element)
            } else {
              element.olditem = this.$formatter.cloneVariable(element)
              items.push(element)
            }
          })
          let transformNumber = {
            number: { list: ['qty', 'minqty', 'orderedqty', 'receivedqty', 'available', 'minstock', 'discountedprice', 'costpricenok'], format: 'replaceDotWithComma' },
            date: { list: ['expirydate'], from: 'DD.MM.YYYY', to: 'DD.MM.YYYY' }
          }
          let modelItems = this.$_formatListModel(items, transformNumber)
          this.orderItems = modelItems
          setTimeout(() => {
            this.onScroll()
          }, 500)
          if (autoSave) {
            setTimeout(() => {
              this.$refs[`qty_${this.orderItems.length - 1}`][0].focus()
              this.isAutoSave = false
            }, 100)
          }
          this.calculateTotalValue(-1, false)
          if (!autoSave) {
            this.$_executeApi('get', `/warehouseorderattachments/get_attachments/${this.supplierObj.id}`).then(response => {
              this.orderAttachment = response.data
            })
          }
        })
        .finally(() => {
          this.fieldsLoading = false
        })
    },
    saveUpdateHandler (type, autoSave) {
      if (this.$refs.supplierOrderRef.$refs.validateForm.validate()) {
        if (this.$refs.orderItems && this.$refs.orderItems.validate()) {
          this.loading = true
          let transformData = { date: { list: ['orderdate', 'estimated_date'], from: 'DD.MM.YYYY', to: 'YYYY-MM-DDTHH:mm:ss' } }
          let model = this.$formatter.cloneVariable(this.supplierObj)
          model = this.$_formatModel(model, transformData)
          let url = this.WH_ORDER
          model.type = CONSTANTS.SUPPLIER
          this.$_saveUpdateHandler(url, model, false, autoSave)
            .then((response) => {
              // const isFirstSave = this.$formatter.cloneVariable(this.supplierObj.id)
              this.supplierObj.id = response.id
              this.supplierObj.status = response.status
              this.$store.commit('isChangesMade', false)
              this.saveOrderItemsHandler(response.id, type, autoSave)
            })
        }
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    saveOrderItemsHandler (id, type, autoSave) {
      if (this.$refs.orderItems.validate()) {
        let transformData = {
          number: { list: ['qty', 'receivedqty', 'minqty', 'unitqty', 'discountedprice', 'costpricenok'], format: 'replaceCommaWithDot' }
        }
        let model = this.$formatter.cloneVariable(this.orderItems)
        model = this.$_formatListModel(model, transformData)
        model.map(x => {
          x.qty = x.qty || 0
          x.costprice = x.discountedprice || 0
          x.costpriceperunit = x.discountedprice || 0
          x.minqty = x.minqty || 0
          x.unitqty = x.unitqty || 0
          if (!x.unitqty) {
            let unitObj = this.listOfUnitMatrix.find(y => y.productid === x.productid && y.issupplier)
            if (unitObj) x.unitqty = unitObj.qty
          }
          if (x.locationid) {
            if (!x.receivedorders) x.receivedorders = []
            if (x.receivedqty) {
              x.receivedorders.push({ batchnumber: x.batchnumber,
                receivedqty: this.$formatter.replaceCommaWithDot(x.receivedqty),
                locationid: x.locationid,
                expirydate: x.expirydate })
            }
          }
          if (x.receivedorders && x.receivedorders.length > 0) {
            x.receivedorders.map(y => {
              y.receivedqty = y.receivedqty ? this.$formatter.replaceCommaWithDot(y.receivedqty) : 0
              y.expirydate = this.$formatter.formatDate(y.expirydate, 'DD.MM.YYYY', 'YYYY-MM-DD')
              return y
            })
          }
          return x
        })
        let orderItemsJSON = { 'items': this.$formatter.cloneVariable(model) }
        let url = `/warehouseorderitems/bulk_save/${id}`
        this.$_executeApi('post', url, orderItemsJSON)
          .then((response) => {
            if (this.supplierObj.file && this.supplierObj.file.length > 0) {
              this.uploadFileHandler(type, id, autoSave)
            }
            if (autoSave) {
              this.orderItems.forEach((element, index) => {
                element.id = response.data[index].id
                element.orderid = id
              })
              if (this.orderItems.length && this.orderItems[0].locationid) {
                this.getSingleRecordHandler(true, autoSave)
              }
              if (this.supplierObj.status === CONSTANTS.RECEIVED || this.supplierObj.status === CONSTANTS.PARTIALLYRECEIVED) this.disableStatusChange = true
              if (!this.$route.params.supp_id) this.$router.push(`/w_h/order/supplierorder/actions/${id}?autosave=true`)
              // history.pushState({}, null, this.$route.path + '/' + id)
            }
          })
          .finally(() => {
            this.loading = false
            if (autoSave) this.getOrderItemsHandler(id)
            if (!autoSave) {
              this.navigateHandler(type, id, autoSave)
            }
          })
      } else {
        this.loading = false
        if (!autoSave) this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
      }
    },
    getActiveProuct (index, productid) {
      // this.changesMade()
      let getProduct = this.orderItems[index].products
      if (getProduct) {
        let result = getProduct.find(x => x.id === productid)
        if (result && result.ispackage) {
          this.loadingProducts = true
          this.getProductsByPackage(productid, index)
        }
        let getObj = this.$formatter.cloneVariable(this.orderItems[index])
        if (getObj) {
          let unitObj = this.listOfUnitMatrix.find(x => x.productid === this.orderItems[index].productid && x.issupplier)
          if (unitObj) {
            getObj.unitid = unitObj.id
            getObj.qty = unitObj && unitObj.orderqty ? this.$formatter.replaceDotWithComma(unitObj.orderqty) : null
            getObj.minqty = unitObj && unitObj.minqty ? this.$formatter.replaceDotWithComma(unitObj.minqty) : null
            getObj.unitqty = unitObj.qty
            getObj.orderedqty = this.$formatter.replaceDotWithComma(unitObj.orderqty * unitObj.qty)
            getObj.totalprice = this.$formatter.replaceDotWithComma(((unitObj.orderqty * unitObj.qty) * (result.discounted || 0)))
          }
          getObj.minstock = this.$formatter.replaceDotWithComma(result.minstock || 0)
          getObj.available = this.$formatter.replaceDotWithComma(result.available || 0)
          getObj.isbatch = result.batchrequired
          getObj.supplierDiscount = this.$formatter.replaceDotWithComma(result.discounted || 0)
          getObj.suppliercurrency = result.currencyname || ''
          getObj.discountedprice = this.$formatter.replaceDotWithComma(result.discounted) || 0
          getObj.costpricenok = this.$formatter.replaceDotWithComma(result.costpricenok) || 0
          this.$set(this.orderItems, index, getObj)
        }
        this.autoSave()
      }
    },
    async unitCalculation (index) {
      await this.updateProductQtyValues(index, true)
      this.calculateTotalValue(index)
    },
    updateProductQtyValues (index, applyToMinQty) {
      return new Promise((resolve, reject) => {
        if (index >= 0) {
          let getObj = this.$formatter.cloneVariable(this.orderItems[index])
          let unitObj = this.listOfUnitMatrix.find(x => x.id === getObj.unitid)
          if (unitObj) {
            if (applyToMinQty) {
              getObj.qty = this.$formatter.replaceDotWithComma(unitObj.orderqty)
              getObj.minqty = this.$formatter.replaceDotWithComma(unitObj.minqty)
            }
            getObj.unitid = unitObj.id
            getObj.orderedqty = this.$formatter.replaceDotWithComma(this.$formatter.replaceCommaWithDot(getObj.qty || 0) * unitObj.qty)
            getObj.unitqty = unitObj.qty
          }
          let getExistingItems = this.$formatter.cloneVariable(this.orderItems)
          getExistingItems.splice(index, 1, getObj)
          this.orderItems = [...getExistingItems.filter(x => x)]
          resolve()
        } else resolve()
      })
    },
    getProductsByPackage (id, index) {
      this.$_executeApi('get', `productpackages/get_package_products/${id}/${this.supplierObj.supplierid || 0}`)
        .then(response => {
          let getAllProducts = []
          let list = response.data
          const conditionObj = this.isMainSupplier ? x => x.supplierid === this.supplierObj.supplierid && x.ismainsupplier : x => x.supplierid === this.supplierObj.supplierid
          list = list.filter(conditionObj)
          for (let i = 0; i < list.length; i++) {
            let unitObj = this.listOfUnitMatrix.find(x => x.productid === list[i].product.id && x.issupplier)
            let products = [{ id: list[i].product.id, productName: list[i].product.number ? `${list[i].product.number} - ${list[i].product.name}` : list[i].product.name }]
            getAllProducts.push({ products,
              productid: list[i].product.id,
              isSelected: false,
              unitid: unitObj && unitObj.id ? unitObj.id : null,
              qty: unitObj && unitObj.orderqty ? this.$formatter.replaceDotWithComma(unitObj.orderqty) : null,
              minqty: unitObj && unitObj.minqty ? this.$formatter.replaceDotWithComma(unitObj.minqty) : null,
              orderedqty: this.$formatter.replaceDotWithComma(unitObj.orderqty * unitObj.qty),
              unitqty: unitObj.qty,
              totalprice: (unitObj && unitObj.qty && list[i].supplierdiscount) ? this.$formatter.replaceDotWithComma(((unitObj.orderqty * unitObj.qty) * (list[i].supplierdiscount || 0))) : 0,
              isbatch: list[i].product.batchrequired,
              available: list[i].product.available ? this.$formatter.replaceDotWithComma(list[i].product.available) : 0,
              minstock: list[i].product.minstock ? this.$formatter.replaceDotWithComma(list[i].product.minstock) : 0,
              productName: list[i].product.number ? `${list[i].product.number} - ${list[i].product.name}` : list[i].product.name,
              productnumber: list[i].product.number,
              productname: list[i].product.name,
              supplierDiscount: list[i].supplierdiscount ? this.$formatter.replaceDotWithComma(list[i].supplierdiscount) : 0,
              discountedprice: list[i].supplierdiscount ? this.$formatter.replaceDotWithComma(list[i].supplierdiscount) : 0,
              costpricenok: list[i].product.costpricenok ? list[i].product.costpricenok : 0,
              suppliercurrency: list[i].suppliercurrency || '',
              olditem: this.$formatter.cloneVariable(list[i]) })
          }
          let getExistingItems = this.$formatter.cloneVariable(this.orderItems)
          getExistingItems.splice(index, 1)
          getExistingItems.push(...getAllProducts)
          this.orderItems = [...getExistingItems.filter(x => x)]
          this.loadingProducts = false
        })
        .finally(() => {
          this.loadingProducts = false
        })
    },
    uploadFileHandler (type, id, autoSave) {
      if (this.supplierObj.file && this.supplierObj.file.length > 0) {
        let url = `warehouseorderattachments/upload/${id}`
        let formData = new FormData()
        for (let i = 0; i < this.supplierObj.file.length; i++) {
          formData.append(this.supplierObj.file[i].name, this.supplierObj.file[i])
        }
        return new Promise((resolve, reject) => {
          this.$_executeApi('post', url, formData)
            .then((response) => {
              resolve()
            })
            .finally(() => {
              this.loading = false
              this.navigateHandler(type, id)
            })
            .catch((error) => {
              reject(error)
            })
        })
      } else {
        this.supplierObj.id = id
        if (!autoSave) this.getSingleRecordHandler()
      }
    },
    checkReceivedQty (index, qty) {
      let items = this.$formatter.cloneVariable(this.orderItems)
      let allItems = items[index].receivedorders
      let getTotal = this.$_getSumBy(allItems, x => x.receivedqty)
      let qtyValue = +this.$formatter.replaceCommaWithDot(qty)
      let recQtyValue = +this.$formatter.replaceCommaWithDot(items[index].receivedqty)
      // eslint-disable-next-line
      if (qtyValue == getTotal) {
        items[index].isMaximumUsed = true
      }
      var getRestQty = (qtyValue - (getTotal + recQtyValue))
      items[index].restqty = getRestQty > 0 ? getRestQty : 0
      this.$set(this.orderItems, index, items[index])
      this.qtyChanged = true
    },
    validateQtyHandler (index, qty) {
      var totalQty = 0
      var loopCount = 0
      if (this.orderItems[index].receivedorders) {
        for (let i = 0; i < this.orderItems[index].receivedorders.length; i++) {
          if (i !== this.orderItems[index].receivedorders.length) {
            let receivedQty = this.$formatter.replaceCommaWithDot(this.orderItems[index].receivedorders[i].receivedqty)
            loopCount += parseFloat(receivedQty)
          }
        }
      }
      totalQty += parseFloat(loopCount)
      if (this.orderItems[index].receivedqty) {
        let parentReceivedQty = this.$formatter.replaceCommaWithDot(this.orderItems[index].receivedqty)
        totalQty += parseFloat(parentReceivedQty)
      }
      if (parseFloat(this.$formatter.replaceCommaWithDot(this.orderItems[index].qty)) < totalQty) {
        this.moreQtyObj = {
          dialog: true,
          onSuccess: () => {
            this.moreQtyObj.dialog = false
          },
          onCancel: () => {
            totalQty = parseFloat(this.$formatter.replaceCommaWithDot(this.orderItems[index].qty)) - parseFloat(loopCount)
            this.orderItems[index].receivedqty = this.$formatter.replaceDotWithComma(totalQty)
            this.moreQtyObj.dialog = false
          }
        }
      } else this.checkReceivedQty(index, this.orderItems[index].qty)
      // this.changesMade()
    },
    navigateHandler (type, id) {
      if (this.$route.params.supp_id && type !== this.UPDATE_CLOSE) this.getSingleRecordHandler()
      else if (type === this.SAVE && id) this.$router.push(`/w_h/order/supplierorder/actions/${id}`)
      // if (type === this.SAVE && id) this.getSingleRecordHandler()
      else if (type === this.UPDATE_CLOSE) this.$router.push('/w_h/order')
    },
    deleteHandler () {
      let ids = [this.supplierObj.id]
      let payload = { ids, url: `${this.WH_ORDER}/delete_multiple`, module: this.WH_ORDER }
      this.$store.commit('showDeleteDialog', payload)
    },
    removeSelectedProducts () {
      let getSelectedIds = this.orderItems.filter(x => x.isSelected && x.id).map(x => x.id)
      let unSavedItemsIndexes = this.orderItems.filter(x => x.isSelected && !x.id).map(x => this.orderItems.indexOf(x))
      /* Commented already
      // let getSelectedIndex =
      // this.orderItems.filter((x, index) => {
      //   if (x.isSelected && !x.id) getSelectedIndex.push(index)
      // }) */

      let availableItems = this.$formatter.cloneVariable(this.orderItems)
      this.deleteObj = {
        dialog: true,
        onSuccess: () => {
          // if (getSelectedIndex.length > 0) {
          //   availableItems = this.orderItems.filter((x, index) => !getSelectedIndex.includes(index))
          //   if (getSelectedIds.length <= 0) {
          //     this.deleteObj.dialog = false
          //     this.orderItems = availableItems
          //   }
          // }
          /* Delete unSavedItems */
          if (unSavedItemsIndexes && unSavedItemsIndexes.length > 0) {
            // const indexSet = new Set(unSavedItemsIndexes)
            availableItems = availableItems.filter((x, i) => !unSavedItemsIndexes.includes(i))
          }
          /* --- */
          /* Delete Saved items */
          if (getSelectedIds.length > 0) {
            let model = { data: { ids: getSelectedIds } }
            this.$_executeApi('delete', 'warehouseorderitems/delete_multiple', model)
              .then(response => {
                this.$root.$emit('snackbar', {
                  snackbar: true,
                  color: 'success',
                  text: this.$t('message.common.deleteSuccess')
                })
                setTimeout(() => {
                  getSelectedIds.map(x => {
                    let getIndex = availableItems.findIndex(y => y.id === x)
                    if (getIndex !== -1) {
                      availableItems.splice(getIndex, 1)
                    }
                  })
                  this.orderItems = availableItems
                  this.deleteObj.dialog = false
                })
              })
          } else {
            this.$root.$emit('snackbar', {
              snackbar: true,
              color: 'success',
              text: this.$t('message.common.deleteSuccess')
            })
            this.orderItems = availableItems
            this.deleteObj.dialog = false
          }
        },
        onClose: () => {
          this.deleteObj.dialog = false
        }
      }
    },
    supportingList (type, text) {
      const modelName = text
      text = this.$refs.supplierOrderRef.$refs[text][0].lazySearch
      let model = { module: type, dialog: true, text, modelName }
      this.$store.commit('supportingList', model)
    },
    // Show and Hide products in the array for performence when having more items
    toggleAllProducts (index, action, productId) {
      let items = this.$formatter.cloneVariable(this.orderItems)
      if (action === this.HIDE && items[index] && items[index].products) {
        let products = items[index].products.filter(x => x.id === productId)
        items[index].products = products
      }
      if (this.orderItems && this.orderItems.length > 0 && this.orderItems[index]) this.$set(this.orderItems, index, items[index])
      // this.autoSave()
    },
    setDefaultValues (data) {
      let { list, prop } = data
      if (list && list.length === 1) {
        let model = Object.assign({ ...this.supplierObj }, { [prop]: list[0].id })
        this.supplierObj = model
      }
    },
    getLocationDefaultValue (data) {
      let { list, warehouseid } = data
      let item = list.find(x => x.isdefault && x.warehouseid === warehouseid)
      if (item) return item
      else return null
    },
    downloadAttachment (index) {
      window.open(process.env.VUE_APP_URL + `/warehouseorderattachments/download/${this.orderAttachment[index].id}`, '_blank')
    },
    deleteAttachment (index) {
      this.$_executeApi('delete', `warehouseorderattachments/${this.orderAttachment[index].id}`).then(response => {
        this.$root.$emit('snackbar', {
          snackbar: true,
          color: 'success',
          text: this.$t('message.common.deleteSuccess')
        })
        this.orderAttachment.splice(index, 1)
      })
    },
    deleteProductRow (index, id) {
      if (this.orderItems[index].id) {
        let payload = { ids: [id], url: `${this.ORDERITEMS}/delete_multiple`, module: this.ORDERITEMS, orderItemsAutoSave: this.$route.params.supp_id || null }
        this.$store.commit('showDeleteDialog', payload)
      } else {
        this.orderItems.splice(index, 1)
        this.calculateTotalValue(-1, true)
      }
    },
    addProductsToList () {
      this.loadingSupplierProducts = true
      const isMainSupplier = this.isMainSupplier ? 1 : 0
      this.$_executeApi('get', `stocks/get_available_products_by_supplier/${this.supplierObj.supplierid}/${isMainSupplier}`)
        .then(response => {
          let getProducts = response.data
          let productsList = []
          getProducts.map(x => {
            x.products = [{ id: x.product.id, productName: x.product.number ? `${x.product.number} - ${x.product.name}` : x.product.name }]
            x.productid = x.product.id
            x.productnumber = x.product.number
            x.productname = x.product.name
            let unitObj = this.listOfUnitMatrix.find(y => y.productid === x.productid && y.issupplier)
            if (!unitObj) unitObj = { id: null, orderqty: 0, minqty: 0, qty: 0 }
            x.unitid = unitObj.id
            // x.qty = this.$formatter.replaceDotWithComma(x.product.unitqty || 0)
            x.qty = unitObj && unitObj.orderqty ? this.$formatter.replaceDotWithComma(unitObj.orderqty) : null
            x.minqty = unitObj && unitObj.minqty ? this.$formatter.replaceDotWithComma(unitObj.minqty) : null
            let orderedQty = 0
            if (unitObj && unitObj.orderqty) orderedQty = (unitObj.orderqty * unitObj.qty)
            orderedQty = this.$formatter.replaceDotWithComma(orderedQty)
            x.orderedqty = orderedQty
            x.unitqty = unitObj.qty
            x.minstock = this.$formatter.replaceDotWithComma(x.product.minstock || 0)
            x.available = this.$formatter.replaceDotWithComma(x.product.available || 0)
            x.isbatch = x.product.batchrequired
            x.supplierDiscount = this.$formatter.replaceDotWithComma(x.supplierdiscount || 0)
            x.discountedprice = this.$formatter.replaceDotWithComma(x.supplierdiscount || 0)
            x.costpricenok = x.product.costprice ? this.$formatter.replaceCommaWithDot(x.product.costprice) : 0
            x.olditem = this.$formatter.cloneVariable(x)
            if (!this.orderItems.find(y => y.productid === x.product.id)) productsList.push(x)
            x.id = 0
            return x
          })
          setTimeout(() => {
            let getItems = this.$formatter.cloneVariable(this.orderItems.filter(x => x.productid))
            getItems.push(...productsList)
            this.orderItems = getItems
            this.calculateTotalValue(-1, true)
          })
        })
        .finally(() => {
          this.loadingSupplierProducts = false
        })
    },
    calculateTotalValue (index, init = false) {
      this.updateProductQtyValues(index)
      let items = this.orderItems
      let total = 0
      let suppliercurrency = ''
      items.map((x, i) => {
        suppliercurrency = x.suppliercurrency
        let qty = +this.$formatter.replaceCommaWithDot(x.orderedqty || 0)
        let price
        if (x.id) {
          price = +this.$formatter.replaceCommaWithDot(x.discountedprice || 0)
        } else {
          price = +this.$formatter.replaceCommaWithDot(x.supplierDiscount || 0)
        }
        total += qty * price
        if (index >= 0 && i === index) {
          this.$set(this.orderItems, i, { ...this.orderItems[index], totalprice: qty * price })
        } else if (init) {
          this.$set(this.orderItems, i, { ...this.orderItems[i], totalprice: qty * price })
        }
      })
      this.totalPrice = total
      this.supplierCurrency = suppliercurrency
      // this.qtyChanged = true
      // if (!init) this.changesMade()
    },
    // Receive all available products with location and Qty
    receiveAllHandler () {
      if (this.supplierObj.id) {
        this.receiveAllLoader = true
        this.$_executeApi('post', `warehouseorders/get_receivable_items_location/${this.supplierObj.id}`)
          .then((response) => {
            if (response && response.data) {
              const availableItems = response.data || []
              const allItems = this.$formatter.cloneVariable(this.orderItems)
              allItems.map(x => {
                const itemObj = availableItems.find(y => y.orderitemid === x.id)
                if (itemObj) {
                  x.listOfLocation = [{
                    id: itemObj.locationid,
                    name: itemObj.locationname
                  }]
                  x.locationid = itemObj.locationid
                  x.receivedqty = x.qty
                }
                return x
              })
              this.orderItems = allItems
            }
          }).finally(() => {
            this.receiveAllLoader = false
          })
      }
    },
    changesMade () {
      this.$store.commit('isChangesMade', true)
    },
    getChildrenCount (id) {
      this.attachmentsCountLoading = true
      this.$_executeApi('get', `sharepoint/get_folder/${id}`)
        .then((response) => {
          if (response && response.data) this.attachmentsCount = response.data.childcount
        }).finally(() => {
          this.attachmentsCountLoading = false
        })
    },
    findSupplierName () {
      let supplier = this.listOfSuppliers.find(x => x.id === this.supplierObj.supplierid)
      if (supplier) this.supplierObj.supplier_name = supplier.name
      this.changesMade()
    },
    onScroll () {
      if (window.pageYOffset <= 0) this.showScrollToTop = false
      else this.showScrollToTop = true
      setTimeout(() => {
        this.onResize()
      })
    },
    onResize () {
      this.showScrollToBottom = window.innerWidth > document.documentElement.clientWidth
    },
    scrollToTop () {
      goTo(0)
    },
    goToBottom () {
      goTo(this.pageHeight)
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$store.state.isChangesMade) {
      next()
    } else {
      this.$store.commit('isChangesMade', true)
      this.$store.commit('changeLostDialog', true)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$root.$off('reloadOrderDetails')
    this.$root.$off('get_supplierorder_details')
  }
}
</script>
<style>
.v-data-table th {
  padding: 0 4px !important;
}
.v-data-table td {
  padding: 0 4px !important;
}
.order_item_table .v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
  font-size: 14px;
  padding: 0 4px !important;
}
.order_item_table .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 35px !important;
}
.custom-max-width div#spDoc > div {
  max-width: 100%;
}
</style>
